import { PlayIcon } from '../../modules/Icons';
import HowDoPlansWorkModal from '../shared/HowDoPlansWorkModal';

import { useState } from 'react';

const HowDoPlansWork: React.FC<{}> = () => {
  const [videoOverlayOpen, setVideoOverlayOpen] = useState<boolean>(false);

  const toggleVideoOverlayOpen = () => setVideoOverlayOpen(!videoOverlayOpen);

  return (
    <>
      <div cy-test-id="how-do-plans-work" className="flex justify-center pt-[66px] pb-[75px]">
        <div
          cy-test-id="clickable"
          className="flex items-center cursor-pointer gap-3 hover:opacity-60"
          onClick={toggleVideoOverlayOpen}
        >
          <PlayIcon className="w-10 h-10" circleFill="#23c1fe" iconFill="#0B1113" circleOpacity="1"/>
          <span className="text-[#23c1fe] text-20 font-bold eurostile uppercase leading-[18px] tracking-tight">
            how our plans work
          </span>
        </div>
      </div>
      <HowDoPlansWorkModal
        isOpen={videoOverlayOpen}
        setIsOpen={setVideoOverlayOpen}
      />
    </>
  )
};

export default HowDoPlansWork;
